module.exports = __webpack_public_path__ + "img/albums-outline.ed3d21cb.svg";